import React, { useEffect, useState } from "react";
import CgInputField from "./CgInputField";
import AutoComplete from "./AutoComplete";
import CgDropdown from "./CgDropdown";
import "./cgFormCreator.scss";
import CgRadioButton from "./CgRadioButton";
import CgCheckbox from "./CgCheckbox";
import CgTextArea from "./CgTextArea";
import ImageCropper from "./ImageUpload";
import CgFileUploader from "./CgFileUploader";
import redAlert from "../assets/images/redAlert.svg";
import { getIsTheValueNotMatchedWithRegex } from "../utils/commonUtilities";

const getIsFieldNotValid = ({ formData, field }) => {
  if (field.required) {
    // if (typeof formData[field.name] === "boolean") {
    //   return false;
    // }
    // /** For number */
    // if (
    //   typeof formData[field.name] === "number" &&
    //   !formData[field.name] &&
    //   formData[field.name] !== 0
    // ) {
    //   return true;
    // }

    /** For strings */

    if (!formData[field.name]?.trim()) {
      return true;
    }
  }

  if (formData[field.name] && field?.inputProps?.pattern) {
    return getIsTheValueNotMatchedWithRegex({
      pattern: field?.inputProps?.pattern,
      value: formData[field.name],
      required: Boolean(field.required),
    });
  }
};

const getFormPrimaryButtonDisabled = ({
  formValues,
  schema,
  canFormCreatorValidateTheForm,
  enablePrimaryBtn,
}) => {
  if (!canFormCreatorValidateTheForm) {
    return !enablePrimaryBtn;
  }

  return schema.some((field) => {
    return getIsFieldNotValid({
      formData: formValues,
      field,
    });
  });
};

const CgFormCreator = ({
  schema,
  onSubmitCallback,
  onCancel,
  primaryButton = "Save",
  secondaryButton = "CANCEL",
  debug = false,
  noSubmit = false,
  needFormHeader = false,
  formHeader = "PROVIDER INFORMATION",
  formClassName,
  noCancel,
  showErrorMsg,
  resetFormValues,
  resetValuesOnSubmit = true, //
  enablePrimaryBtn = true,
  canFormCreatorValidateTheForm = false,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [resetValues, setResetValues] = useState(false);
  const [formValues, setFormValues] = useState({}); // Store checkbox selections

  useEffect(() => {
    if (resetValuesOnSubmit) {
      setResetValues(true);
      setFormValues({});
      setTimeout(() => {
        setResetValues(false);
      }, 2000);
    }
  }, [resetFormValues]);

  useEffect(() => {
    setTimeout(() => {
      setErrorMessage("");
    }, 2000);
  }, [errorMessage]);
  // Capture Checkbox Selections
  const handleCheckboxChange = (name, values) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: values,
    }));
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    try {
      const formData = new FormData(event.target);
      let data = Object.fromEntries(formData.entries());

      // **Include Checkboxes in Submission**
      schema.forEach((field) => {
        if (field.component === "checkbox") {
          data[field.name] =
            formValues[field.name] || field.defaultValues || [];
        }
      });

      // **Validation**
      const errors = {};
      schema.forEach((field) => {
        const { name, required, label } = field;
        if (required && (!data[name] || data[name].length === 0)) {
          errors[name] = `${label} is required`;
        }
      });

      if (Object.keys(errors).length > 0) {
        setErrorMessage("Please fill in all the required fields.");
        console.error(errors);
        return;
      }

      if (debug) {
        console.log("Validated Data:", data);
      }

      onSubmitCallback(data);
      if (resetValuesOnSubmit) {
        setResetValues(true);
        setTimeout(() => {
          setResetValues(false);
        }, 2000);
      }
    } catch (error) {
      if (debug) {
        console.log(error);
      }
    }
  };
  return (
    <div
      className={`cgFormCreatorWrapper ${
        !needFormHeader ? "noBorder" : "withBorder"
      }`}
    >
      {needFormHeader && <div className="formCreatorHeader">{formHeader}</div>}
      <div className={`cgForm ${!needFormHeader ? "noForm" : ""}`}>
        <form onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="alert alert-danger">{errorMessage}</div>
          )}
          <div className={formClassName ? formClassName : "mb-3"}>
            {schema.map((schemaItem, index) => {
              if (schemaItem.component === "checkbox") {
                return (
                  <div
                    className={
                      schemaItem.className
                        ? schemaItem.className
                        : `field${index}`
                    }
                    key={index}
                  >
                    <CgCheckbox
                      {...schemaItem}
                      defaultValues={schemaItem.defaultValues || []}
                      onSelect={(selected) =>
                        handleCheckboxChange(schemaItem.name, selected)
                      }
                      resetValue={resetValues}
                    />
                  </div>
                );
              }
              // Other Components (Dropdown, Input, etc.)
              return (
                <div
                  className={
                    schemaItem.className
                      ? schemaItem.className
                      : `field${index}`
                  }
                  //  className={`field${index}`}
                  key={index}
                >
                  {schemaItem.component === "input" && (
                    <CgInputField
                      {...schemaItem}
                      resetValue={resetValues}
                      onKeyChangeCallback={(...args) => {
                        /**
                         * args = [fieldName, value]
                         */
                        setFormValues((prev) => ({
                          ...prev,
                          [args[0]]: args[1],
                        }));
                        if (schemaItem?.onKeyChangeCallback) {
                          schemaItem.onKeyChangeCallback(...args);
                        }
                      }}
                    />
                  )}
                  {schemaItem.component === "dropdown" && (
                    <CgDropdown
                      {...schemaItem}
                      resetValue={resetValues}
                      onSelectCallBack={(...args) => {
                        /**
                         * args = [fieldName, value, selectedItem]
                         */
                        setFormValues((prev) => ({
                          ...prev,
                          [args[0]]: args[1],
                        }));
                        if (schemaItem?.onSelectCallBack) {
                          schemaItem.onSelectCallBack(...args);
                        }
                      }}
                    />
                  )}
                  {schemaItem.component === "custom" &&
                    schemaItem.customRender()}
                  {schemaItem.component === "radio" && (
                    <CgRadioButton {...schemaItem} resetValue={resetValues} />
                  )}
                  {schemaItem.component === "autoComplete" && (
                    <AutoComplete {...schemaItem} resetValue={resetValues} />
                  )}
                  {schemaItem.component === "textarea" && (
                    <CgTextArea {...schemaItem} resetValue={resetValues} />
                  )}
                  {schemaItem.component === "imageUploader" && (
                    <ImageCropper {...schemaItem} resetValue={resetValues} />
                  )}
                  {schemaItem.component === "fileUploader" && (
                    <CgFileUploader {...schemaItem} resetValue={resetValues} />
                  )}
                  {schemaItem.component === "custom" && schemaItem.customRender}
                </div>
              );
            })}
          </div>
          {!showErrorMsg ||
            (showErrorMsg !== "" && (
              <div
                className="missing-data-info"
                style={{ paddingTop: "unset" }}
              >
                <div>
                  <img
                    className="missing-data-img"
                    src={redAlert}
                    alt="Missing Info Image"
                  />
                </div>
                <div className="missing-data">
                  <p> {showErrorMsg}</p>
                </div>
              </div>
            ))}
          {!noSubmit && (
            //   ${
            //   !enablePrimaryBtn ? "disable" : ""
            // }
            <div className="cgFormButtonWrapper">
              <button
                disabled={getFormPrimaryButtonDisabled({
                  formValues,
                  schema,
                  canFormCreatorValidateTheForm,
                  enablePrimaryBtn,
                })}
                className={`saveBtn ${!enablePrimaryBtn ? "disable" : ""} `}
                type="submit"
              >
                {/* // <button className="saveBtn" type="submit" style={enablePrimaryBtn ? {"opacity" : 0.5, "pointerEvet"}}> */}
                {primaryButton}
              </button>
              {!noCancel && (
                <button
                  className="cancelBtn"
                  type="reset"
                  onClick={() => {
                    onCancel();
                    if (resetValuesOnSubmit) {
                      setResetValues(true);
                      setTimeout(() => {
                        setResetValues(false);
                      }, 2000);
                    }
                  }}
                >
                  {secondaryButton}
                </button>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};
export default CgFormCreator;
